/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateEventLocationLookup = /* GraphQL */ `
  subscription OnCreateEventLocationLookup {
    onCreateEventLocationLookup {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEventLocationLookup = /* GraphQL */ `
  subscription OnUpdateEventLocationLookup {
    onUpdateEventLocationLookup {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEventLocationLookup = /* GraphQL */ `
  subscription OnDeleteEventLocationLookup {
    onDeleteEventLocationLookup {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onCreateEventCompany = /* GraphQL */ `
  subscription OnCreateEventCompany {
    onCreateEventCompany {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventCompany = /* GraphQL */ `
  subscription OnUpdateEventCompany {
    onUpdateEventCompany {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventCompany = /* GraphQL */ `
  subscription OnDeleteEventCompany {
    onDeleteEventCompany {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          showPersonal
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEvent = /* GraphQL */ `
  subscription OnCreateEvent {
    onCreateEvent {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEvent = /* GraphQL */ `
  subscription OnUpdateEvent {
    onUpdateEvent {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEvent = /* GraphQL */ `
  subscription OnDeleteEvent {
    onDeleteEvent {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      registerInterest
      notifyRegisterInterest
      customAppointmentReminder
      reminderTime
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          internalUse
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventLocation = /* GraphQL */ `
  subscription OnCreateEventLocation {
    onCreateEventLocation {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventLocation = /* GraphQL */ `
  subscription OnUpdateEventLocation {
    onUpdateEventLocation {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventLocation = /* GraphQL */ `
  subscription OnDeleteEventLocation {
    onDeleteEventLocation {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventCollectUserData = /* GraphQL */ `
  subscription OnCreateEventCollectUserData {
    onCreateEventCollectUserData {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventCollectUserData = /* GraphQL */ `
  subscription OnUpdateEventCollectUserData {
    onUpdateEventCollectUserData {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventCollectUserData = /* GraphQL */ `
  subscription OnDeleteEventCollectUserData {
    onDeleteEventCollectUserData {
      id
      label
      questionType
      validation
      fieldType
      internalUse
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        registerInterest
        notifyRegisterInterest
        customAppointmentReminder
        reminderTime
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventCollectUserDataOptions = /* GraphQL */ `
  subscription OnCreateEventCollectUserDataOptions {
    onCreateEventCollectUserDataOptions {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEventCollectUserDataOptions = /* GraphQL */ `
  subscription OnUpdateEventCollectUserDataOptions {
    onUpdateEventCollectUserDataOptions {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEventCollectUserDataOptions = /* GraphQL */ `
  subscription OnDeleteEventCollectUserDataOptions {
    onDeleteEventCollectUserDataOptions {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        internalUse
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const onCreateEventSlotGroup = /* GraphQL */ `
  subscription OnCreateEventSlotGroup {
    onCreateEventSlotGroup {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventSlotGroup = /* GraphQL */ `
  subscription OnUpdateEventSlotGroup {
    onUpdateEventSlotGroup {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventSlotGroup = /* GraphQL */ `
  subscription OnDeleteEventSlotGroup {
    onDeleteEventSlotGroup {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          registerInterest
          notifyRegisterInterest
          customAppointmentReminder
          reminderTime
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventSlot = /* GraphQL */ `
  subscription OnCreateEventSlot {
    onCreateEventSlot {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventSlot = /* GraphQL */ `
  subscription OnUpdateEventSlot {
    onUpdateEventSlot {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventSlot = /* GraphQL */ `
  subscription OnDeleteEventSlot {
    onDeleteEventSlot {
      id
      time
      length
      type
      booked
      isDeleted
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          customReminder
          attendance
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventBooking = /* GraphQL */ `
  subscription OnCreateEventBooking {
    onCreateEventBooking {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEventBooking = /* GraphQL */ `
  subscription OnUpdateEventBooking {
    onUpdateEventBooking {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEventBooking = /* GraphQL */ `
  subscription OnDeleteEventBooking {
    onDeleteEventBooking {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      customReminder
      attendance
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        eventBooking {
          nextToken
        }
      }
    }
  }
`;
export const onCreateEventCommsTemplate = /* GraphQL */ `
  subscription OnCreateEventCommsTemplate {
    onCreateEventCommsTemplate {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateEventCommsTemplate = /* GraphQL */ `
  subscription OnUpdateEventCommsTemplate {
    onUpdateEventCommsTemplate {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteEventCommsTemplate = /* GraphQL */ `
  subscription OnDeleteEventCommsTemplate {
    onDeleteEventCommsTemplate {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateEventCommsTemplateAttachments = /* GraphQL */ `
  subscription OnCreateEventCommsTemplateAttachments {
    onCreateEventCommsTemplateAttachments {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEventCommsTemplateAttachments = /* GraphQL */ `
  subscription OnUpdateEventCommsTemplateAttachments {
    onUpdateEventCommsTemplateAttachments {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEventCommsTemplateAttachments = /* GraphQL */ `
  subscription OnDeleteEventCommsTemplateAttachments {
    onDeleteEventCommsTemplateAttachments {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const onCreateEventClientAccess = /* GraphQL */ `
  subscription OnCreateEventClientAccess {
    onCreateEventClientAccess {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onUpdateEventClientAccess = /* GraphQL */ `
  subscription OnUpdateEventClientAccess {
    onUpdateEventClientAccess {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onDeleteEventClientAccess = /* GraphQL */ `
  subscription OnDeleteEventClientAccess {
    onDeleteEventClientAccess {
      id
      expiryDate
      clientPassword
      showPersonal
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const onCreateBookingError = /* GraphQL */ `
  subscription OnCreateBookingError {
    onCreateBookingError {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateBookingError = /* GraphQL */ `
  subscription OnUpdateBookingError {
    onUpdateBookingError {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteBookingError = /* GraphQL */ `
  subscription OnDeleteBookingError {
    onDeleteBookingError {
      id
      error
      payload
      browser
      createdAt
      updatedAt
    }
  }
`;
